<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Digital Printed Garments
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Overview</a>
          <ul>
            <li @click="activeMenuLink = 'digitalprint/dashboard'"><router-link to="/digitalprint/dashboard"  :class="{'is-active':activeMenuLink === 'digitalprint/dashboard'}">Dashboard</router-link></li>
            <li @click="activeMenuLink = 'digitalprint/scheduler'"><router-link to="/digitalprint/scheduler"  :class="{'is-active':activeMenuLink === 'digitalprint/scheduler'}">Scheduler</router-link></li>
            
          </ul>
        </li>
        <li>
          <a class="">Artwork</a>
          <ul>
            <li @click="activeMenuLink = 'digitalprint/incoming-orders'"><router-link to="/digitalprint/incoming-orders"  :class="{'is-active':activeMenuLink === 'digitalprint/incoming-orders'}">Incoming Orders <span v-if="incoming_orders_count.order_count > 0">({{ incoming_orders_count.order_count }})</span></router-link></li>
            <li @click="activeMenuLink = 'digitalprint/new-artwork'"><router-link to="/digitalprint/new-artwork"  :class="{'is-active':activeMenuLink === 'digitalprint/new-artwork'}">New Artwork <span v-if="new_artwork_orders_count.order_count > 0">({{ new_artwork_orders_count.order_count }})</span></router-link></li>
            <li @click="activeMenuLink = 'digitalprint/quality'"><router-link to="/digitalprint/quality"  :class="{'is-active':activeMenuLink === 'digitalprint/quality'}">Quality Check <span v-if="quality_check_orders_count.order_count > 0">({{ quality_check_orders_count.order_count }})</span></router-link></li>
            <li @click="activeMenuLink = 'digitalprint/quality2'"><router-link to="/digitalprint/quality2"  :class="{'is-active':activeMenuLink === 'digitalprint/quality2'}">Quality Check 2 <span v-if="quality_check_2_orders_count.order_count > 0">({{ quality_check_2_orders_count.order_count }})</span></router-link></li>
            
          </ul>
        </li>
        
        <li style="display:none">
          <a class="">Printing</a>
          <ul>
            <li @click="activeMenuLink = 'digitalprint/printing-paper'"><router-link to="/digitalprint/printing-paper"  :class="{'is-active':activeMenuLink === 'digitalprint/printing-paper'}">Paper</router-link></li>
            <li @click="activeMenuLink = 'digitalprint/printing-rolls'"><router-link to="/digitalprint/printing-rolls"  :class="{'is-active':activeMenuLink === 'digitalprint/printing-rolls'}">Rolls</router-link></li>
          <li @click="activeMenuLink = 'digitalprint/cutting'"><router-link to="/digitalprint/cutting"  :class="{'is-active':activeMenuLink === 'digitalprint/cutting'}">Cutting</router-link></li>
          </ul>
        </li>
        
       

<li>
          <a class="">Reports </a>
          <ul>
            
            <li @click="activeMenuLink = 'digitalprint/artwork-finished'"><router-link to="/digitalprint/artwork-finished"  :class="{'is-active':activeMenuLink === 'digitalprint/artwork-finished'}">Artworks Finished</router-link></li>
            <li @click="activeMenuLink = 'digitalprint/repeat-artworks'"><router-link to="/digitalprint/repeat-artworks"  :class="{'is-active':activeMenuLink === 'digitalprint/repeat-artworks'}">Repeat Artworks</router-link></li>
            <li @click="activeMenuLink = 'digitalprint/qc-finished'"><router-link to="/digitalprint/qc-finished"  :class="{'is-active':activeMenuLink === 'digitalprint/qc-finished'}">QC Finished</router-link></li>
          </ul>
        </li>
         <li>
          <a class="">Admin </a>
          <ul>
            
            <li @click="activeMenuLink = 'digitalprint/view-order'"><router-link to="/digitalprint/view-order"  :class="{'is-active':activeMenuLink === 'digitalprint/view-order'}">View Order</router-link></li>
            
            
          </ul>
        </li>
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";
import OrderService from '@/services/OrderService.js';

export default {
  name: 'SideBarDigitalPrint',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { activeMenuLink: null,
    count_only: 1,
    incoming_orders_count: [],
    new_artwork_orders_count: [],
    quality_check_orders_count: [],
    quality_check_2_orders_count: [] }
  },
  methods: {
      async getOrders() {
        
        OrderService.getIncomingArtworkOrders(this.accessToken, "", this.order_by, this.count_only)
        .then(
          (orders => {
            this.$set(this, "incoming_orders_count", orders[0]);
            
          }).bind(this)
        );

        OrderService.getNewArtworkOrders(this.accessToken, "", "", "", this.count_only)
        .then(
          (orders => {
            this.$set(this, "new_artwork_orders_count", orders[0]);
            
          }).bind(this)
        );

        OrderService.getQualityArtworkOrders(this.accessToken, "", "", this.order_by, this.count_only)
        .then(
          (orders => {
            this.$set(this, "quality_check_orders_count", orders[0]);
            
          }).bind(this)
        );

        OrderService.getQuality2ArtworkOrders(this.accessToken, "", this.order_by, this.count_only)
        .then(
          (orders => {
            this.$set(this, "quality_check_2_orders_count", orders[0]);
            
          }).bind(this)
        );
        
      },
  },
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getLocations();
           //this.getArtworkers();
        });

        
  },
  mounted() {
    this.activeMenuLink = this.$route.path.substring(1)
    console.log(this.$route.path)

    window.setInterval(() => {
      this.getOrders()
    }, 300000)
  }
}

</script>



